import { Injectable, inject } from '@angular/core';
import { HowdenHttpClientService, IPageOf, IResponse } from '@howdeniberia/core-front';
import { Observable, map, of } from 'rxjs';
import { API_PATH_APPS } from 'src/app/core/constants';
import { IApiResponse, IClient, IGetProjectsOutputDto, IProjectInputDto, IProjectOutputDto, ISearchRequest, ISearchResult } from 'src/app/core/models/api/sane-project/arpa-model';
import { SaneProjectContract } from './sane-project.contract';

@Injectable({
  providedIn: 'root'
})
export class SaneProjectService implements SaneProjectContract {
  private http = inject(HowdenHttpClientService);

  private readonly basePath = 'api/arpaprojects';
  private readonly clientsPath = 'api/arpaclients';

  search(request: ISearchRequest): Observable<IPageOf<ISearchResult>> {
    const url = `${this.basePath}/get-projects`;
    return this.http
      .post<IApiResponse<IGetProjectsOutputDto>>(API_PATH_APPS.API_PERSONAL_INSURANCE, url, request)
      .pipe(
        map(response => {
          const dto = response.result;
          const raw = Array.isArray(dto.projects) ? dto.projects : [];
          const data = raw.map(p => ({
            projectId: p.projectId,
            projectDate: p.projectDate ? new Date(p.projectDate) : undefined,
            projectName: p.projectName ?? '',
            totalBonus: Number(p.totalBonus ?? 0),
            clientId: p.clientId !== null && p.clientId !== undefined ? Number(p.clientId) : undefined, clientName: p.clientName ?? '',
            clientProfession: p.professionName ?? '',
            clientAge: p.clientAge !== null && p.clientAge !== undefined ? p.clientAge.toString() : '',
            userId: p.user ?? '',
            userName: p.user ?? '',
            officeAlias: p.officeAlias?.trim() ?? '',
            officeName: p.officeName ?? ''
          } as ISearchResult));
          return {
            pageNumber: dto.pageNumber,
            pageSize: dto.pageSize,
            itemCount: dto.itemCount,
            totalCount: dto.totalCount,
            totalPages: dto.totalPages,
            data
          };
        })
      );
  }

  getProjectById(id: number): Observable<IProjectOutputDto> {
    const url = `${this.basePath}/${id}`;
    return this.http
      .get<IApiResponse<IProjectOutputDto>>(API_PATH_APPS.API_PERSONAL_INSURANCE, url)
      .pipe(map(r => r.result));
  }

  save(project: IProjectOutputDto): Observable<IProjectOutputDto> {
    return of(project);
  }

  getClient(id: number): Observable<IClient> {
    const url = `${this.clientsPath}?clientId=${id}`;
    return this.http.get<IClient>(API_PATH_APPS.API_PERSONAL_INSURANCE, url);
  }

  getPricing(input: IProjectInputDto): Observable<IResponse<number>> {
    const url = `${this.basePath}/get-pricing`;
    return this.http.post<IResponse<number>>(API_PATH_APPS.API_PERSONAL_INSURANCE, url, input);
  }

  canBeSigned(projectId: number): Observable<IResponse<boolean>> {
    return this.http.get<IResponse<boolean>>(API_PATH_APPS.API_PERSONAL_INSURANCE, `${this.basePath}/${projectId}/can-be-signed`);
  }

  generateReport(projectId: number): Observable<Blob> {
    return this.http.getBlob(API_PATH_APPS.API_PERSONAL_INSURANCE, `${this.basePath}/${projectId}/generate-report`, {
      reportProgress: true,
      responseType: 'blob'
    });
  }
}
